<script>
  import { onMount } from "svelte";
  import * as PropTypes from "prop-types";
  const { checkPropTypes, bool, string } = PropTypes;
  export let classes = "";
  export let shouldLoadVideo;
  export let ariaLabel = "";

  const propTypes = {
    classes: string,
    shouldLoadVideo: bool,
    ariaLabel: string,
  };
  onMount(() => {
    checkPropTypes(propTypes, $$props, "prop", "SwipeItem");
  });
</script>

<div aria-label={ariaLabel} class="swipeable-item {classes}">
  <!-- This Block is to remove "default props passed" warning in svelte  -->
  {#if false}
    <slot />
  {/if}
  <!--  -->

  {#if shouldLoadVideo}
    <slot name="video" />
  {:else}
    <slot name="poster" />
  {/if}
</div>

<style>
  .swipeable-item {
    position: relative;
    width: inherit;
    height: inherit;
  }
</style>
